// extracted by mini-css-extract-plugin
export default {"dialog":"Popup_dialog__bIeSU"};